import React, { useEffect, useState } from "react";
import "./Garage.css";
import { Col, Container, Row } from "react-bootstrap";

import { getUserBikesAPI } from "../../Services/BikeService";
import { useAuth } from "../../Context/useAuth";

import { BikeModel } from "../../Models/BikeModel";
import UserBikeList from "../../Components/UserBikeList/UserBikeList";


const Garage = () => {
  const { isLoggedIn, user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState("parts");
  const [showDetails, setShowDetails] = useState(false);
  const [userBikes, setUserBikes] = useState<BikeModel[]>([]);

  useEffect(() => {
  const getUserBikesInit = async (id: string) => {
    getUserBikesAPI(id)
      .then((res) => {
        if (res?.data) {
          setUserBikes(res?.data);
        }
      })
      .catch((e) => {
        setUserBikes([]);
      });
  };
    if (user){
      getUserBikesInit(user.id);
    }
  }, []);
  

  return (

    <section className="garage">
      <Container className="headding">
        <Row>
          <Col>
            <h1>My Garage</h1>
          </Col>
          <Col className="d-flex justify-content-end">
          </Col>
        </Row>
      </Container>
      <UserBikeList searchResults={ userBikes }/>
    </section>

  );
};

export default Garage;
